import { render } from "./Destacado.vue?vue&type=template&id=7daf95f6&scoped=true"
import script from "./Destacado.vue?vue&type=script&lang=js"
export * from "./Destacado.vue?vue&type=script&lang=js"

import "./Destacado.vue?vue&type=style&index=0&id=7daf95f6&lang=scss&scoped=true"

import exportComponent from "/proyectos/servicios/ide-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7daf95f6"]])

export default __exports__